export default __webpack_public_path__ + "static/media/pim.218cb827.svg";